import React, { useState } from "react";

const CustomTooltip = ({ tooltipHeading, tooltipSubtext, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <div
      className="tooltip-container"
      onClick={showTooltip}
      onMouseLeave={hideTooltip}
    >
      {/* Tooltip text */}
      {isVisible && (
        <div className="tooltip-text p-2">
          <div className="text-uppercase tooltip-heading">{tooltipHeading}</div>
          <div className="text-uppercase tooltip-subtext">{tooltipSubtext}</div>
        </div>
      )}

      {/* The element that triggers the tooltip */}
      <span className="tooltip-trigger">{children}</span>
    </div>
  );
};

export default CustomTooltip;
